module.exports = __webpack_public_path__ + "img/logo.8ca3e6f1.svg";